module.exports = __webpack_public_path__ + "static/media/icon-plus.4dbe8b31.svg";